import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { mapCartResponse } from '@core/models/cart.mapper';
import { CartResponse } from '@core/models/cart.response';
import { CartState } from '@core/models/cart.state';
import { FulfilmentMethod } from '@core/models/listing.enum';
import { ApiService } from '@core/services/api.service';

import { CartRepository } from './cart.repository';

/** Every cart mutation returns the updated `CartResponse`, so all methods map the same way. */
@Injectable()
export class CartHttpRepository implements CartRepository {
  private readonly api = inject(ApiService);

  get(ownerKey: string): Observable<CartState> {
    return this.api.get<CartResponse>(`carts/${ownerKey}`).pipe(map(mapCartResponse));
  }

  addLine(ownerKey: string, listingId: number, fulfilment: FulfilmentMethod): Observable<CartState> {
    return this.api.post<CartResponse>(`carts/${ownerKey}/lines`, { listingId, fulfilment }).pipe(map(mapCartResponse));
  }

  updateLineFulfilment(ownerKey: string, lineId: number, fulfilment: FulfilmentMethod): Observable<CartState> {
    return this.api.patch<CartResponse>(`carts/${ownerKey}/lines/${lineId}`, { fulfilment }).pipe(map(mapCartResponse));
  }

  removeLine(ownerKey: string, lineId: number): Observable<CartState> {
    return this.api.delete<CartResponse>(`carts/${ownerKey}/lines/${lineId}`).pipe(map(mapCartResponse));
  }

  saveForLater(ownerKey: string, lineId: number): Observable<CartState> {
    return this.api.post<CartResponse>(`carts/${ownerKey}/lines/${lineId}/save`, null).pipe(map(mapCartResponse));
  }

  moveToCart(ownerKey: string, lineId: number): Observable<CartState> {
    return this.api.post<CartResponse>(`carts/${ownerKey}/lines/${lineId}/restore`, null).pipe(map(mapCartResponse));
  }

  merge(guestKey: string, shopperKey: string): Observable<CartState> {
    return this.api.post<CartResponse>('carts/merge', { guestKey, shopperKey }).pipe(map(mapCartResponse));
  }

  clear(ownerKey: string): Observable<CartState> {
    return this.api.delete<CartResponse>(`carts/${ownerKey}`).pipe(map(mapCartResponse));
  }
}
